import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import getCurrencySymbol from 'dibs-currency-helpers/getCurrencySymbol';
import ArrowDownIcon from 'dibs-vg/dist/react/arrow-down';
import CheckmarkIcon from 'dibs-vg/dist/react/checkmark';

import style from './CurrencyDropdown-style.scss';

class CurrencyDropdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isExpanded: false
        };

        this.handleSelectorClick = this.handleSelectorClick.bind(this);
        this.handleOptionClick = this.handleOptionClick.bind(this);
        this.closeDropdown = this.closeDropdown.bind(this);
    }

    componentDidMount() {
        window.addEventListener('click', this.closeDropdown);
    }

    openDropdown() {
        this.setState({ isExpanded: true });
    }

    closeDropdown() {
        this.setState({ isExpanded: false });
    }

    handleSelectorClick(event) {
        event.stopPropagation();
        this.openDropdown();
    }

    handleOptionClick(event) {
        event.preventDefault();
        event.stopPropagation();

        const selectedCurrency = event.currentTarget.getAttribute('data-currency');

        this.props.onChange(selectedCurrency);
        this.closeDropdown();
    }

    render() {
        return (
            <div className={style.selector}>
                <div className={style.label}>
                    <FormattedMessage
                        id='dbl.Footer.CurrencyDropdown.label'
                        defaultMessage='Currency'
                    />
                </div>
                <div className={style.value} onClick={this.handleSelectorClick}>
                    {getCurrencySymbol(this.props.currency)} {this.props.currency}
                    <ArrowDownIcon className={style.arrow} />

                    {this.state.isExpanded ?
                        <ul className={style.dropdown}>
                            {this.props.currencies.map((currency) => (
                                <li key={currency}>
                                    <span onClick={this.handleOptionClick} className={style.option} data-currency={currency}>
                                        {this.props.currency === currency ? <CheckmarkIcon className={style.checkmark} /> : null}
                                        <span className={style.optionLabel}>{getCurrencySymbol(currency)} {currency}</span>
                                    </span>
                                </li>
                            ))}
                        </ul>
                    : null}
                </div>
            </div>
        );
    }
}

CurrencyDropdown.propTypes = {
    currencies: PropTypes.arrayOf(PropTypes.string).isRequired,
    currency: PropTypes.string.isRequired,
    onChange: PropTypes.func
};

CurrencyDropdown.defaultProps = {
    onChange: () => {}
};

export default CurrencyDropdown;



// WEBPACK FOOTER //
// ./src/components/Footer/CurrencySelector/CurrencyDropdown.jsx